import React from "react";
import { Box, Flex, Link, Text } from "@chakra-ui/react";
import { useColorModeValue } from "../components/ui/color-mode";

const HomeFooter = () => {
  const mutedTextColor = useColorModeValue("gray.600", "gray.300");
  const linkColor = useColorModeValue("teal.700", "teal.300");

  return (
    <Box as="footer" maxW="1180px" mx="auto" px={{ base: 5, md: 8 }} py={8}>
      <Flex wrap="wrap" gap={4} justify="space-between" align="center">
        <Text fontSize="sm" color={mutedTextColor}>
          DCF Teacher helps investors learn discounted cash flow and reverse DCF analysis.
        </Text>
        <Flex wrap="wrap" gap={4}>
          <Link href="/about" color={linkColor}>
            About
          </Link>
          <Link href="/tutorials" color={linkColor}>
            Tutorials
          </Link>
          <Link href="/metrics" color={linkColor}>
            Public KPI Data
          </Link>
          <Link href="/browse" color={linkColor}>
            Browse
          </Link>
          <Link href="/changelog" color={linkColor}>
            Changelog
          </Link>
        </Flex>
      </Flex>
    </Box>
  );
};

export default HomeFooter;
